/*
  lp-ddsl-page.js: page JS for sections/lp-dd-hb-sugar-loop.liquid (HB Sugar Loop Cascade Deep Dive).
  Lives in assets/ because the theme editor strips inline <script> from section markup.
  Port of assets/lp-ddhci-page.js (chin-insulin C run), rebound to .ddsl / data-ddsl-*.

  1. Lazy loops: video.ddsl-loop gets its src (data-ddsl-src) and plays near the viewport; pauses
     off-screen. Nothing plays under prefers-reduced-motion (CSS also hides the video, so the poster
     background shows).
  2. Smooth scroll for this page's own CTAs (data-ddsl-cta), header offset, plus a guarded CTA event.
     Buy-box and sticky links are left alone.
  The proof chart grows once via snippets/lp-dd-bars (doctors DD module), not here.
  Optional globals are always guarded (typeof window.fireEvent === 'function').
*/
(function () {
  'use strict';

  var root = document.querySelector('.ddsl');
  if (!root) return;

  var HEADER_OFFSET = 70;
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* ignore */ }
  var hasIO = typeof window.IntersectionObserver === 'function';

  function fire(name, payload) {
    if (typeof window.fireEvent === 'function') {
      try { window.fireEvent(name, payload || {}); } catch (e) { /* ignore */ }
    }
  }

  /* ---------- 1. Lazy loops ---------- */
  var loops = root.querySelectorAll('video.ddsl-loop[data-ddsl-src]');
  function startLoop(v) {
    if (!v.getAttribute('src')) {
      v.setAttribute('src', v.getAttribute('data-ddsl-src'));
      try { v.load(); } catch (e) { /* ignore */ }
    }
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked: poster stays */ });
  }
  if (!reduceMotion && loops.length) {
    if (hasIO) {
      var loopIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { startLoop(v); } else if (v.getAttribute('src')) { try { v.pause(); } catch (e) { /* ignore */ } }
        });
      }, { rootMargin: '200px 0px' });
      Array.prototype.forEach.call(loops, function (v) { loopIO.observe(v); });
    } else {
      Array.prototype.forEach.call(loops, startLoop);
    }
  }

  /* ---------- 2. Smooth scroll + CTA event ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-ddsl-cta][href^="#"]') : null;
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var el = id ? document.getElementById(id) : null;
    if (!el) return;
    e.preventDefault();
    var top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    try { window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (err) { window.scrollTo(0, top); }
    fire('lp_cta_click', { page: 'lp-dd-hb-sugar-loop', slot: a.getAttribute('data-ddsl-cta') });
  });
})();
